import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AppServiceManager } from '../../../common/services/appServiceManager';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService} from 'primeng/api';
import { Configuration } from 'config/config';
import { Asset } from "app/shared/Domains/asset";
import { HttpClient } from '@angular/common/http';
import { CalendarModule } from 'primeng/calendar';
import { IBranch } from "app/shared/Domains/branch";
import { AppUtils } from 'common/services/app.util';
import { NgxSpinnerService } from "ngx-spinner";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { DatePipe } from "@angular/common";
import { WebcamImage, WebcamInitError, WebcamUtil } from "ngx-webcam";
import { BreadcrumbService } from 'app/breadcrumb.service';

@Component({
  selector: "app-add-asset",
  templateUrl: "./add-assets.component.html",
  styleUrls: ["./add-assets.component.css"]
})
export class AddAssetComponent implements OnInit {
  assetForm: FormGroup;
  asset: Asset = new Asset();
  categories : any = []; // Example categories (you'll fetch them dynamically)
  currentUser: string;
  companySessionStorage: any;
  branchSessionStorage: any;
  addProfileImage: any;
  dialogVisibility: boolean;
  uploadProfile: any;
  uploadProfilePath: any;
  public webcamImage: WebcamImage = null;

  constructor(
    private fb: FormBuilder,
    private LanguageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public config: Configuration,
    private _http: HttpClient,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private loader: NgxSpinnerService,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Add Asset' },
      { label: 'Add Asset', routerLink: ['/add-assets'] }
    ]);
    this.LanguageService = LanguageService;

  }

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AddAssetComponent", label);
  }
  ngOnInit(): void {
    // Initialize the form group with controls and validators
    this.assetForm = this.fb.group({
      name: ['', Validators.required],
      profile: [''],
      category: ['', Validators.required],
      purchaseDate: ['', Validators.required],
      status: ['', Validators.required],
      cost: ['', [Validators.required, Validators.min(0)]],
      serialNumber: ['', Validators.required],
      description: [''],
      warrantyExpire: [''],
    });
    this.currentUser = localStorage.getItem('currentUser');
    const currentUseroBJ = JSON.parse(this.currentUser);
    this.companySessionStorage = currentUseroBJ.company;
    this.branchSessionStorage = currentUseroBJ.branch;
    this.addProfileImage = "Upload";
    this.dialogVisibility = false;

    // Load categories when the component initializes
    this.loadCategories();
  }

  // Method to load categories
  loadCategories(): void {
    // Temporary static list of gym categories
    this.categories = [
        { label: "Cardio Equipment", value: 'Cardio Equipment' },
        { label: "Strength Equipment", value: 'Strength Equipment' },
        { label: "Flexibility Equipment", value: 'Flexibility Equipment' },
        { label: "Accessories", value: 'Accessories' },
    ];
}

validateAssetSignup(form: any) {
  if (form.controls['name'].invalid) {
      const nameInput = document.getElementById('name');
      nameInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
      });
  }
  if (form.controls['category'].invalid) {
      const nameInput = document.getElementById('category');
      nameInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
      });
  }
  if (form.valid) {
     this.onSubmit();
  }
  else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
          const control = form.controls[controlName];
          control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
  }
}


  // Method to handle form submission
  async onSubmit(): Promise<void> {
      this.asset.branch = this.branchSessionStorage;
      this.asset.company = this.companySessionStorage;
      this.asset.serialNumber = this.asset.serialNumber.toString();

      try {
        // Await the result of the asset creation API call
        const res = await this.appServiceManager.post('assets', this.asset).toPromise();

        // Display success message for asset creation
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Asset successfully added.',
        });

        // Check if the asset was created successfully and has an _id
        if (res.asset._id && this.uploadProfile) {
          // Prepare and upload the image only after asset creation
          const file = AppUtils.base64ToFile(
            this.uploadProfile,
            `${this.asset.name}.png:${this.companySessionStorage}:${this.branchSessionStorage}`
          );

          // Await the result of the upload function
          await this.uploadAssetImage(file, res.asset._id);
        }

        // Reset the form after successful submission
        this.resetForm();
      } catch (error) {
        // Handle errors for asset creation
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to add asset.',
        });
      }
  }


  // Method to reset the form after successful submission
  resetForm(): void {
    this.assetForm.reset();
  }

  clearProfile($event: any) {
    this.asset.profile = "assets/layout/images/2.png";
}

captureImageDialogShow(type: any) {
    this.addProfileImage = type; // Upload | Cam
    this.dialogVisibility = true;
}
hideAddProfileImage() {
    this.dialogVisibility = false;
}
handleImagefromNewProfile(webcamImage: string) {
  if (webcamImage) {
      this.uploadProfile = webcamImage;
      this.asset.profile = webcamImage;
      this.webcamImage = null;
      this.hideAddProfileImage();
  }
}
removeProfileImage() {
  this.uploadProfile = '';
  this.asset.profile = '';
}

uploadAssetImage(file: any, assetId: string | Blob, isAddMode = false) {
  let formData: FormData = new FormData();
  if (file) {

      formData.append("assetImage", file, file.name);
      formData.append("isThumb", "true");
      formData.append("assetId", assetId);
      formData.append("company", this.companySessionStorage);
      formData.append("branch", this.branchSessionStorage);
      formData.append("isAddMode", isAddMode.toString());

      this.appServiceManager.post("assets/upload", formData)
          .subscribe(
              (res: any) => {
              },
              (error: any) => {
                  this.messageService.clear();
                  this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
              }
          );
  }
}


}
